import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useState } from "react";
import classNames from "classnames";
import { Carousel } from "react-responsive-carousel";

import { BrandPhoto } from "custom-types/Brand";

import Image from "components/Image";

const BrandPhotoCarousel: React.FC<{
  photos: BrandPhoto[];
  imageSizing?: boolean;
}> = ({ photos, imageSizing }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const adjustContainerSizing =
    imageSizing && photos.length < 2 ? "h-[185px] w-full md:h-[575px]" : "";

  return (
    // TODO: Add accessibility features and remove aria-hidden (https://leafly.atlassian.net/browse/BRND-125)
    <div aria-hidden data-testid="brand-photo-carousel">
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        showArrows={false}
        selectedItem={currentIndex}
        onChange={setCurrentIndex}
      >
        {photos.map((photo, i) => (
          <div key={photo.id}>
            <div className={adjustContainerSizing}>
              <Image
                alt={photo.caption}
                sizes={[400, 600, 800, 1000, null, 800]}
                src={photo.imageUrl}
                disableLazyLoad={i === 0}
              />
            </div>
          </div>
        ))}
      </Carousel>

      {photos.length > 1 && (
        <div className="flex justify-center items-start z-0 mt-xl">
          {photos.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              style={{ height: 12, width: 12 }}
              className={classNames(
                "rounded-full mx-xs",
                {
                  "bg-default": currentIndex === i,
                },
                {
                  "bg-light-grey": currentIndex !== i,
                }
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandPhotoCarousel;
